export default function hasUppercaseLetter(value: string) {
  return /[A-Z]/.test(value);
}
